import { VersionGate } from '@frameio/shared/account-migration/VersionGate';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { AccountLockingEventsSubscription } from './account-locking/AccountLockingEventsSubscription';
import { AccountUpdateAlertSubscription } from './account-update-alert/AccountUpdateAlertSubscription';
import { BalanceEventsSubscription } from './balance/BalanceEventsSubscription';
import { InboxUnopenedCountSubscription } from './inbox/InboxUnopenedCountSubscription';
import { AccountNotificationGroupEventsSubscription } from './notification-events/AccountNotificationGroupEventsSubscription';
import { ResourceControlPolicyEventsSubscription } from './resource-control-policy-events/ResourceControlPolicyEvents';
import { StorageEventsSubscription } from './storage/StorageEventsSubscription';

/**
 * subscribe to account-level events.
 * include this high up in your tree, like in your main app layout
 * */
export const AccountSubscriptions = () => {
  const accountId = useActiveAccountId();

  return (
    <VersionGate>
      <InboxUnopenedCountSubscription accountId={accountId} />
      <AccountNotificationGroupEventsSubscription accountId={accountId} />
      <ResourceControlPolicyEventsSubscription />
      <AccountLockingEventsSubscription />
      <AccountUpdateAlertSubscription />
      <BalanceEventsSubscription />
      <StorageEventsSubscription />
    </VersionGate>
  );
};
